import {Component, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {merge, Observable, of, Subject} from 'rxjs/index';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/internal/operators';

@Component({
  selector: 'formly-autocomplete',
  template: `
      <div class="form-group">
          <div class="input-group">
              <input class="form-control formly-autocomplete" [formControl]="formControl"
                     container="body"
                     [formlyAttributes]="field" [ngbTypeahead]="search"
                     [inputFormatter]="autoOptions.inputFormatter"
                     [editable]="autoOptions.editable"
                     [showHint]="autoOptions.showHint"
                     [focusFirst]="autoOptions.focusFirst"
                     (selectItem)="autoOptions.selectItem($event, model)"
                     [resultFormatter]="autoOptions.resultFormatter">
              <div *ngIf="searchFailed" i18n>{{autoOptions.messageNotFound}}</div>
              <button *ngIf="autoOptions.isMapIcon" class="btn btn-primary text-white" (click)="autoOptions.openMap($event)" title="Open map"><i class="fa fa-crosshairs"></i></button>
              <span *ngIf="autoOptions.clearOption" class="btn btn-secondary" title="Clear" (click)="autoOptions.clearItem($event, model)">Clear</span>
          </div>
      </div>
  `,
})
export class AutocompleteTypeComponent extends FieldType implements OnInit {
  field;
  model;
  searching = false;
  searchFailed = false;
  autoOptions = {
    editable: true,
    messageNotFound: 'Sorry, suggestions could not be loaded.',
    showHint: false,
    focusFirst: true,
    displayField: '',
    isMapIcon: true,
    clearOption: false,
    openMap:(e) => {},
    clearItem:(event, model) => {},
    selectItem: (event, model) => {
    },
    inputFormatter: (x) => this.autoOptions.displayField ? x[this.autoOptions.displayField] : x,
    resultFormatter: (x) => this.autoOptions.displayField ? x[this.autoOptions.displayField] : x,
  };

  focus$ = new Subject<string>();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.field.templateOptions.autoOptions) {
      Object.assign(this.autoOptions, this.field.templateOptions.autoOptions);
    }
  }

  search = (text$: Observable<string>) => {
    if (this.autoOptions) {
      if (this.autoOptions['localData']) {
        return merge(this.focus$, text$.pipe(
          debounceTime(200),
          distinctUntilChanged())
        ).pipe(
          map(term => term['length'] < 2 ? []
            : this.autoOptions['localData'].filter(v => v.toLowerCase().indexOf(term['toLowerCase']()) > -1).slice(0, 10))
        );
      }

      if (this.autoOptions['remoteData']) {
        return merge(this.focus$, text$.pipe(
          debounceTime(1000),
          distinctUntilChanged())
        ).pipe(
          tap(() => this.searching = true),
          switchMap((term) => {
              return this.autoOptions['remoteData'](term).pipe(
                tap(() => this.searchFailed = false),
                catchError(() => {
                  this.searchFailed = true;
                  return of([]);
                }));
            }
          ),
          tap(() => this.searching = false)
        );
      }
    }
    return text$.pipe(map(term => []));
  }
}
